exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2-d0m2QUcxy-MeCym5IA8y {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.mIqkw7WSvZXQS3kiYJGmB {\n  font-size: 0.5em;\n}\n\n.mmJN4cVbficDwBMDQAPWE {\n  max-width: 90vw;\n  position: absolute;\n  z-index: 1500;\n}\n", ""]);

// exports
exports.locals = {
	"short": "_2-d0m2QUcxy-MeCym5IA8y",
	"dots": "mIqkw7WSvZXQS3kiYJGmB",
	"popover": "mmJN4cVbficDwBMDQAPWE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./src/widgets/CodeTooltip/styles.css
// module id = 16
// module chunks = 0 1 2